function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "REJ-3",
  transform: "translate(-180.000000, -694.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(103.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Registration_form",
  transform: "translate(75.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Check/Off",
  transform: "translate(1.000000, 493.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 23,
  height: 23
}), /*#__PURE__*/React.createElement("g", {
  id: "checkbox",
  transform: "translate(1.150000, 1.150000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.35,14.7085 C10.0260465,14.7054395 9.71469879,14.5825391 9.476,14.3635 L5.658,10.81 C5.32520709,10.4977499 5.18427722,10.031676 5.28829731,9.58734379 C5.3923174,9.14301161 5.72548432,8.78792581 6.16229732,8.65584377 C6.59911032,8.52376173 7.07320711,8.63474986 7.406,8.947 L10.2235,11.592 L14.398,6.7735 C14.6165021,6.51557587 14.9291453,6.35583306 15.2661851,6.32990692 C15.603225,6.30398077 15.9366213,6.41402825 16.192,6.6355 C16.4506438,6.85604106 16.6106482,7.17062956 16.6365526,7.50954535 C16.662457,7.84846113 16.5521218,8.18371252 16.33,8.441 L11.293,14.26 C11.0660562,14.5235005 10.7429667,14.6850452 10.396,14.7085 L10.35,14.7085 Z",
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7,0 C18.909139,-4.05812251e-16 20.7,1.790861 20.7,4 L20.7,16.7 C20.7,18.909139 18.909139,20.7 16.7,20.7 L4,20.7 C1.790861,20.7 1.15871992e-15,18.909139 0,16.7 L0,4 C-2.705415e-16,1.790861 1.790861,1.29399067e-15 4,0 L16.7,0 Z M16.55,1.15 L4.15,1.15 C2.49314575,1.15 1.15,2.49314575 1.15,4.15 L1.15,4.15 L1.15,16.55 C1.15,18.2068542 2.49314575,19.55 4.15,19.55 L4.15,19.55 L16.55,19.55 C18.2068542,19.55 19.55,18.2068542 19.55,16.55 L19.55,16.55 L19.55,4.15 C19.55,2.49314575 18.2068542,1.15 16.55,1.15 L16.55,1.15 Z",
  id: "Shape",
  fill: "#C8C8C8"
})))))));

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Checked.1d44419c.svg";
export { ForwardRef as ReactComponent };